import React from "react";
import { Box, Typography, useTheme } from "@mui/material";
import { alpha } from "@mui/material/styles";

interface Props {
  title: string;
  children: React.ReactNode;
}

const SyndicatorCard: React.FC<Props> = ({ title, children }) => {
  const theme = useTheme();
  const accent = theme.palette.status.accent;
  return (
    <Box
      sx={{
        backgroundColor: theme.palette.background.paper,
        border: `1px solid ${alpha(accent, 0.55)}`,
        borderRadius: 2,
        p: 2,
      }}
    >
      <Typography
        variant="subtitle1"
        sx={{ mb: 2, fontWeight: 600, color: accent, letterSpacing: 0.3 }}
      >
        {title}
      </Typography>
      {children}
    </Box>
  );
};

export default SyndicatorCard;
